module.exports = __webpack_public_path__ + "static/assets/40fe6fdeb376ee345f39b1497c7e1b6a.svg";